import { Grid, TextField, Autocomplete } from '@mui/material'
import { surahs, surahVerses } from '../constants/quranData'

function QuranProgressFields({
  surah,
  verse,
  onSurahChange,
  onVerseChange,
  surahLabel,
  verseLabel,
}) {
  // Generate surah options with numbers
  const surahOptions = surahs.map((surahName, index) => ({
    label: `${index + 1}. ${surahName}`,
    value: surahName
  }));

  // Generate verse options based on the selected surah
  const verseOptions = Array.from(
    { length: surahVerses[surah] || 0 }, 
    (_, i) => ({ label: `${i + 1}`, value: i + 1 })
  );

  // Find the current surah option
  const currentSurahOption = surahOptions.find(option => option.value === surah) || null;
  
  // Find the current verse option
  const currentVerseOption = verseOptions.find(option => option.value === verse) || null;

  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <Autocomplete
          value={currentSurahOption}
          onChange={(event, newValue) => {
            onSurahChange({ target: { value: newValue?.value || '' } });
          }}
          options={surahOptions}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label={surahLabel} 
              variant="outlined" 
              fullWidth
            />
          )}
          isOptionEqualToValue={(option, value) => option.value === value.value}
        />
      </Grid>
      <Grid item xs={6}>
        <Autocomplete
          value={currentVerseOption}
          onChange={(event, newValue) => {
            onVerseChange({ target: { value: newValue?.value || 1 } });
          }}
          options={verseOptions}
          renderInput={(params) => (
            <TextField 
              {...params} 
              label={verseLabel} 
              variant="outlined" 
              fullWidth
            />
          )}
          isOptionEqualToValue={(option, value) => option.value === value.value}
        />
      </Grid>
    </Grid>
  )
}

export default QuranProgressFields
